import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Card, DisplayText, Stack, Tooltip, Icon, TextStyle } from '@shopify/polaris';
import { InfoMinor } from '@shopify/polaris-icons';

import TransferItemForShow from "@presentational/transfer/components/TransferItemForShow";
import TransferItemHeaders from "@presentational/transfer/components/TransferItemHeaders";
import TransferItemFooter from "@presentational/transfer/components/TransferItemFooter";

import { transferShape } from 'utils/shapeProps';

const propTypes = {
  transfer: transferShape.isRequired,
}

const defaultProps = {

}

// LEGACY COMPONENT

const TransferShowGeneralInfo = (props) => {
  const { transfer } = props;

  // const currentSaleStatus = transfer.sale_status.replace("sale_","");
  const currentSaleStatusParsed = transfer.sale_status.replace("sale_","");
  const anyPaymentPresent = transfer.total_invoice_by_source.totals_by_source.length > 0; // totals_by_source is an array of objects

  return (
    <div className="generalInfo container-fluid pt15 pb15">

      <div className="card-bg-black-0">
        <Card sectioned>
          <DisplayText size="small" >
            { `${I18n.t("activerecord.attributes.transfer.invoice_number")}:` } <strong>{ transfer.invoice_number }</strong>
          </DisplayText>
        
          <Stack spacing="extraTight">
            <DisplayText size="small" >
              Total: <strong>{ transfer.invoice_amount_money }</strong> /
            </DisplayText>
            <Tooltip content={ anyPaymentPresent > 0 ? 
              <div>
                { transfer.total_invoice_by_source.totals_by_source.map( (item) => (
                  <p key={item.key}>{ `${item.label}:` } <strong>{item.value_money}</strong></p>
                ))}
                <hr/>
                <p>Total: <strong>{ transfer.invoice_amount_paid_money }</strong></p>
              </div>
              : null
            }>
              <p className='Polaris-DisplayText Polaris-DisplayText--sizeSmall flex'>
                Abonado: <strong style={{ marginRight: 4 }}>{ transfer.invoice_amount_paid_money }</strong> { anyPaymentPresent && 
                  <Icon color="white" source={ InfoMinor } />
                }
              </p>
            </Tooltip>
          </Stack>
        </Card>
      </div>

      <div className="flex mt10">

        <div className={`mb30 flexContainer statusProgressContainer ${transfer.status} `}>
          <Card>
            <div className="bg-body flex justifyCenter pv15 ph15">
              <TextStyle variation="strong">{ I18n.t("activerecord.attributes.transfer.total_shipped") } </TextStyle>
            </div>
            <Card.Section>
              <div className="flex justifyCenter">
                <DisplayText size="medium">
                  { transfer.total_shipped } de { transfer.total_to_ship }
                </DisplayText>
              </div>
            </Card.Section>
          </Card>
        </div>
        <div className={`mb30 flexContainer statusProgressContainer ${currentSaleStatusParsed}`}>
          <Card>
            <div className="bg-body flex justifyCenter pv15 ph15">
              <TextStyle variation="strong">{ I18n.t("activerecord.attributes.transfer.total_sold") }</TextStyle>
            </div>

            <Card.Section>
              <div className="flex justifyCenter">
                <DisplayText size="medium">
                  { transfer.total_sold } de { transfer.total_to_ship }
                </DisplayText>
              </div>
            </Card.Section>
          </Card>
        </div>

      </div>

      <Card sectioned>

        {/* Headers for items */}
        <TransferItemHeaders
          forForm={ false }
        />
        <div className="flex flexColumn flexColumnReverse">
          {transfer.products_transfers.map((pt, index) => (
            <TransferItemForShow item={ pt } key={index} currencySymbol={ transfer.currency_symbol } />
          ))}
        </div>
        <TransferItemFooter transfer={ transfer} />
      </Card>
    </div>
  )
};

TransferShowGeneralInfo.propTypes = propTypes;
TransferShowGeneralInfo.defaultProps = defaultProps;

export default TransferShowGeneralInfo;